import task from './modules/task';

export default {
	namespaced: true,
	state: () => ({}),
	mutations: {},
	actions: {},
	getters: {},

	//	嵌套模块,继承父模块的命名空间
	modules: {
		task,
	},
};



// WEBPACK FOOTER //
// ./src/store/Welfare/index.js